import React, { useState, useEffect } from "react";
import { BsQuestionSquare } from "react-icons/bs";

const Tooltip = ({ children, tooltipText }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [tooltipWidth, setTooltipWidth] = useState(420);

  // Check if viewing on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      // Adjust tooltip width based on screen size for better responsiveness
      setTooltipWidth(window.innerWidth < 500 ? window.innerWidth * 0.9 : 420);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  // Handle mouse enter to calculate position
  const handleMouseEnter = (e) => {
    if (isMobile) return;

    const triggerRect = e.currentTarget.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    // Calculate the ideal center position
    let idealX = triggerRect.left + triggerRect.width / 2;

    // Adjust if tooltip would overflow on the right
    const rightOverflow = idealX + tooltipWidth / 2 - viewportWidth;
    if (rightOverflow > 0) {
      idealX -= rightOverflow;
    }

    // Adjust if tooltip would overflow on the left
    if (idealX - tooltipWidth / 2 < 0) {
      idealX = tooltipWidth / 2;
    }

    setTooltipPosition({
      x: idealX,
      y: triggerRect.top,
    });

    setIsVisible(true);
  };

  // Handle mobile tap to show tooltip
  const handleTooltipTrigger = () => {
    if (isMobile) {
      setIsVisible(!isVisible);
    }
  };

  return (
    <span className='inline-flex items-center relative'>
      {/* Make text normal (not bold) */}
      <span className='font-normal'>{children}</span>

      <span
        className='inline-block ml-1 text-purple cursor-help'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => !isMobile && setIsVisible(false)}
        onClick={handleTooltipTrigger}
      >
        <BsQuestionSquare size={14} />
      </span>

      {/* Desktop tooltip - no scrollbar or maxHeight */}
      {isVisible && !isMobile && (
        <div
          className='fixed p-3 bg-inaqgold text-center text-white text-sm rounded-xs shadow-md z-50 font-rubik font-light'
          style={{
            width: `${tooltipWidth}px`,
            maxWidth: "100vw",
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y - 10}px`,
            transform: "translate(-50%, -100%)",
            fontSmoothing: "antialiased",
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
          }}
        >
          {tooltipText || "No tooltip text provided"}
          <div className='absolute top-full left-1/2 -translate-x-1/2 -mt-1 w-2 h-2 bg-inaqgold text-center transform rotate-45'></div>
        </div>
      )}

      {/* Mobile tooltip (modal style) - also without maxHeight */}
      {isVisible && isMobile && (
        <>
          <div
            className='fixed inset-0 bg-black bg-opacity-50 z-40'
            onClick={() => setIsVisible(false)}
          />
          <div
            className='fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-4 bg-inaqgold text-white text-[13px] rounded-xs shadow-lg z-50 font-rubik font-light'
            style={{
              width: "90vw",
              fontSmoothing: "antialiased",
              WebkitFontSmoothing: "antialiased",
              MozOsxFontSmoothing: "grayscale",
              lineHeight: "1.8",
            }}
          >
            <div className='mt-2'>
              {tooltipText || "No tooltip text provided"}
            </div>
            <button
              className='absolute top-1 right-4 text-white'
              onClick={() => setIsVisible(false)}
            >
              ✕
            </button>
          </div>
        </>
      )}
    </span>
  );
};

export default Tooltip;
